import * as Sentry from '@sentry/react';

// choose console levels by env
const isProdLike = ['production'].includes(import.meta.env.MODE);
//const isProdLike = ["production", "staging"].includes(import.meta.env.MODE);
const consoleLevels = isProdLike
  ? ['warn', 'error'] // production: only the important stuff
  : ['log', 'warn', 'error']; // local/dev: see more during debugging

Sentry.init({
  // disable Sentry in dev mode
  enabled: isProdLike,
  environment: import.meta.env.MODE, // helpful for filtering in Sentry
  // Enable logs to be sent to Sentry
  enableLogs: true,
  // DSN endpoint for Sentry
  dsn: 'https://163d6ee1cfe6c3f0b440ecb06b299d56@o4509940896628736.ingest.us.sentry.io/4509944770330624',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  // debug: true, TEMP: see SDK diagnostics in the console
  sendDefaultPii: true,
  integrations: [
    Sentry.replayIntegration(),
    Sentry.browserTracingIntegration(),
    Sentry.consoleLoggingIntegration({ levels: consoleLevels as any }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
  // Session Replay
  // Keep replay modest in prod, richer during dev
  replaysSessionSampleRate: isProdLike ? 0.1 : 1.0,
  //replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,

  // Guardrails to avoid noise/PII and oversized payloads
  normalizeDepth: 6, // avoid giant objects
  maxValueLength: 1000,

  // Filter noisy/known-ignorable errors
  ignoreErrors: [
    // Browser/extension noise
    //"ResizeObserver loop limit exceeded",
    //"ResizeObserver loop completed with undelivered notifications",
    //
    // React dev warnings that sometimes get thrown as Errors
    //"Non-Error promise rejection captured",
    //
    // Chunk/refresh transient errors (keep if they’re actionable for you)
    // "Loading chunk * failed",
  ],

  // Ignore events coming from 3rd-party or extensions
  denyUrls: [/extensions\//i, /^chrome:\/\//i, /safari-web-extension/i],

  // Optionally restrict to your own app’s origins
  // allowUrls: [/^https:\/\/(www\.)?yourdomain\.com\//],

  // As a last-resort filter
  beforeSend(event, hint) {
    // Example: don’t send events without a message/exception
    const hasError = event.exception?.values?.length || event.message;
    if (!hasError) return null;

    // Example: drop very noisy network errors
    const msg = (event.message || '').toLowerCase();
    if (msg.includes('network error') || msg.includes('load failed')) {
      return isProdLike ? null : event;
    }

    return event;
  },
});

// quick test events on load
// Sentry.captureMessage("Sentry JS is initialized");
// Sentry.logger.info("Sentry logger is enabled", { source: "bootstrap" });

// (optionally) ensure delivery in dev before page unload
// Sentry.flush(2000);
